module.exports = __webpack_public_path__ + "img/new.ade1181e.gif";